/* VERSANDFORTSCHRITT — Live-Verhalten.
 *
 * Der groesste Teil braucht gar kein JavaScript: Dawn rendert bei jeder
 * Warenkorb-Aenderung selbst neu. Gemessen am 25.08.2026 aus cart.js und
 * cart-drawer.js:
 *   Warenkorbseite -> #main-cart-footer, Auswahl .js-contents
 *   Mini-Warenkorb -> #CartDrawer, komplett ersetzt
 * Beide Auftritte liegen genau dort und ziehen deshalb von selbst mit,
 * einschliesslich der Vorschlaege, die Liquid rendert.
 *
 * Diese Datei uebernimmt nur, was Dawn nicht abdeckt:
 *   1. die Anzeige auf der PRODUKTSEITE, die Dawn nicht neu rendert
 *   2. den Dazulegen-Knopf an den Vorschlaegen
 */
(function () {
  "use strict";

  var doc = document;

  /* Muss dem money-Filter des Themes entsprechen: 23,95€ ohne Leerzeichen. */
  function euro(cent) {
    return (cent / 100).toFixed(2).replace(".", ",") + "€";
  }

  /* Setzt Text und Balken einer Anzeige neu. Die Vorschlaege bleiben, wo
     Liquid sie gerendert hat - nur wenn die Schwelle erreicht ist, muessen
     sie weg, denn dann sind sie sachlich falsch. */
  function setzen(el, summe) {
    var schwelle = parseInt(el.getAttribute("data-mvv-schwelle"), 10) || 5000;
    var rest = Math.max(0, schwelle - summe);
    var erreicht = summe >= schwelle;
    var prozent = Math.max(0, Math.min(100, Math.round((summe * 100) / schwelle)));
    // Nicht erreicht heisst nicht voll: 49,99 EUR rundet sonst auf 100 %,
    // und ein voller Balken neben "Noch 0,01 EUR" widerspricht sich.
    if (!erreicht && prozent >= 100) prozent = 99;

    var text = el.querySelector(".mvv__text");
    var balken = el.querySelector(".mvv__balken");
    var fuell = balken && balken.querySelector("i");

    if (text) {
      if (erreicht) {
        text.innerHTML = '<b class="mvv__ok">Kostenloser Versand erreicht&nbsp;✓</b>';
      } else {
        var korb = summe > 0
          ? '<span class="mvv__korb">Warenkorb: <b>' + euro(summe) + "</b></span> " +
            '<span class="mvv__trenn" aria-hidden="true">·</span> '
          : "";
        text.innerHTML = korb +
          '<span class="mvv__rest">Noch <b>' + euro(rest) +
          "</b> bis zum kostenlosen Versand</span>";
      }
    }
    if (balken) {
      balken.setAttribute("aria-valuenow", String(prozent));
      balken.setAttribute("aria-valuetext", erreicht
        ? "Kostenloser Versand erreicht"
        : "Noch " + euro(rest) + " bis zum kostenlosen Versand");
    }
    if (fuell) fuell.style.width = prozent + "%";

    el.classList.toggle("is-erreicht", erreicht);

    var liste = el.querySelector(".mvv__vg");
    var titel = el.querySelector(".mvv__vl");
    if (erreicht) {
      if (liste) liste.remove();
      if (titel) titel.remove();
    }
  }

  /* Nur die Anzeigen aktualisieren, die Dawn NICHT selbst neu rendert.
     Alles innerhalb #CartDrawer oder #main-cart-footer laesst man in Ruhe -
     sonst schreibt man Dawns frischen Stand mit einem aelteren zu. */
  function aktualisieren(summe) {
    var alle = doc.querySelectorAll(".mvv");
    for (var i = 0; i < alle.length; i++) {
      var el = alle[i];
      if (el.closest("#CartDrawer") || el.closest("#main-cart-footer")) continue;
      setzen(el, summe);
    }
  }
  window.mvVersandAktualisieren = aktualisieren;

  function ausKorbLesen() {
    return fetch(window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root + "cart.js" : "/cart.js",
        { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (k) { aktualisieren(k.items_subtotal_price); return k; });
  }

  /* Welche Abschnitte diese Seite neu gerendert haben will. Genau die Namen,
     die Dawn selbst benutzt - sonst kommt nichts zurueck. */
  function abschnitte() {
    var s = [];
    var p = doc.getElementById("main-cart-items");
    var f = doc.getElementById("main-cart-footer");
    if (p && p.dataset.id) s.push(p.dataset.id);
    if (f && f.dataset.id) s.push(f.dataset.id);
    /* Die Schublade NUR ausserhalb der Warenkorbseite anfordern. Auf /cart
       zeigt Dawn sie gar nicht an - sie dort neu aufzubauen loest nur ihr
       Oeffnen aus, und das sperrt das Scrollen der ganzen Seite. */
    if (!p && doc.querySelector("cart-drawer")) s.push("cart-drawer");
    if (doc.getElementById("cart-icon-bubble")) s.push("cart-icon-bubble");
    return s;
  }

  function innenHTML(html, auswahl) {
    var d = new DOMParser().parseFromString(html, "text/html").querySelector(auswahl);
    return d ? d.innerHTML : null;
  }

  function einspielen(antwort) {
    var abs = antwort.sections || {};
    var aufKorbSeite = !!doc.getElementById("main-cart-items");
    var schublade = doc.querySelector("cart-drawer");
    /* renderContents ruft am Ende open(). Auf der Warenkorbseite setzt das
       'overflow-hidden' auf den Body: die Seite liess sich danach nicht mehr
       scrollen, obwohl die Schublade unsichtbar blieb. Am 25.08.2026 an der
       laufenden Seite gemessen. Deshalb dort gar nicht anfassen. */
    if (!aufKorbSeite && schublade && abs["cart-drawer"] && typeof schublade.renderContents === "function") {
      schublade.renderContents(antwort);
    }
    var f = doc.getElementById("main-cart-footer");
    if (f && f.dataset.id && abs[f.dataset.id]) {
      var neu = innenHTML(abs[f.dataset.id], ".js-contents");
      var ziel = f.querySelector(".js-contents");
      if (neu !== null && ziel) ziel.innerHTML = neu;
    }
    var p = doc.getElementById("main-cart-items");
    if (p && p.dataset.id && abs[p.dataset.id]) {
      var neu2 = innenHTML(abs[p.dataset.id], ".js-contents");
      var ziel2 = p.querySelector(".js-contents");
      if (neu2 !== null && ziel2) ziel2.innerHTML = neu2;
    }
    /* Die Zahl am Warenkorb-Symbol im Kopf. Genau so, wie Dawn es selbst macht. */
    var b = doc.getElementById("cart-icon-bubble");
    if (b && abs["cart-icon-bubble"]) {
      var neu3 = innenHTML(abs["cart-icon-bubble"], ".shopify-section");
      var ziel3 = b.querySelector(".shopify-section") || b;
      if (neu3 !== null) ziel3.innerHTML = neu3;
    }
  }

  /* Andere Bausteine duerfen dieselben zwei Helfer benutzen, statt Dawns
     Abschnitts-Namen ein zweites Mal zu fuehren - zwei Kopien laufen sonst
     irgendwann auseinander. mv-korb-groesse.js haengt daran. */
  window.mvDawn = { abschnitte: abschnitte, einspielen: einspielen };

  /* Dazulegen-Knopf an den Vorschlaegen. Delegiert, weil die Liste bei jedem
     Neurendern ersetzt wird - ein direkt gesetzter Handler waere danach weg. */
  doc.addEventListener("click", function (e) {
    var knopf = e.target.closest ? e.target.closest(".mvv__add") : null;
    if (!knopf) return;
    e.preventDefault();
    var vid = knopf.getAttribute("data-vid");
    if (!vid || knopf.disabled) return;

    /* Braucht der Vorschlag eine Groesse, klappt der erste Klick sie auf und
       sperrt den Knopf, bis gewaehlt ist. Ohne Groesse geht hier nichts in den
       Korb - sonst stuende in der Bestellung ein Knickschutz, bei dem niemand
       weiss, welches Paar zu packen ist. */
    var karte = knopf.closest(".mvv__v");
    var bereich = karte ? karte.querySelector(".mvv__vgr") : null;
    var feld = bereich ? bereich.querySelector("[data-mvg]") : null;

    if (feld) {
      if (bereich.hidden) {
        bereich.hidden = false;
        knopf.setAttribute("aria-expanded", "true");
        knopf.disabled = true;
        feld.focus();
        return;
      }
      if (!feld.value) {
        feld.classList.add("is-fehlt");
        feld.focus();
        return;
      }
    }

    var posten = { id: Number(vid), quantity: 1 };
    if (feld && feld.value) {
      /* Der Name kommt aus dem Feld selbst, nicht aus einer zweiten Schreibweise
         im Skript - "Größe Paar 1" mit echtem Umlaut, Wort fuer Wort wie auf
         der Produktseite. */
      posten.properties = {};
      posten.properties[feld.getAttribute("data-mvg-name")] = feld.value;
    }

    knopf.disabled = true;
    var alt = knopf.textContent;
    knopf.textContent = "…";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        items: [posten],
        sections: abschnitte(),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { if (!r.ok) throw new Error("add"); return r.json(); })
      .then(function (a) {
        /* Zuruecksetzen und einklappen: die Kaertchen im Warenkorb und in der
           Schublade rendert Dawn ohnehin neu, das auf der Produktseite nicht. */
        if (feld) { feld.value = ""; feld.classList.remove("is-fehlt"); }
        if (bereich) bereich.hidden = true;
        knopf.setAttribute("aria-expanded", "false");
        knopf.disabled = false;
        knopf.textContent = alt;
        einspielen(a);
        return ausKorbLesen();
      })
      .catch(function () {
        knopf.disabled = false;
        knopf.textContent = alt;
      });
  });

  /* Sobald eine Groesse gewaehlt ist, wird der Knopf wieder frei. Delegiert,
     weil Dawn die Liste bei jeder Warenkorb-Aenderung ersetzt. */
  doc.addEventListener("change", function (e) {
    var feld = e.target;
    if (!feld || !feld.hasAttribute || !feld.hasAttribute("data-mvg")) return;
    var karte = feld.closest(".mvv__v");
    var knopf = karte ? karte.querySelector(".mvv__add") : null;
    feld.classList.toggle("is-fehlt", !feld.value);
    if (knopf) knopf.disabled = !feld.value;
  });

  /* ---------------------------------------------------------------
     RESERVIERUNGSANZEIGE — Aufsicht, keine eigene Zeitrechnung.

     Die Uhr auf der Warenkorbseite ist das Theme-Element <countdown-element>
     aus assets/db_.162.510d9c6665466c3e6791.js — dasselbe, das im
     Warenkorb-Fenster laeuft. Es fuehrt sein ENDDATUM im Browserspeicher unter
     dem Schluessel "countdown"; genau dadurch zeigen beide Uhren dieselbe
     Restzeit. Hier wird deshalb NICHTS nachgerechnet und NICHTS in diesen
     Schluessel geschrieben. Eine zweite Rechnung waere die einzige
     Moeglichkeit, dass die beiden Uhren auseinanderlaufen.

     ENTFERNT am 05.09.2026: An dieser Stelle stand eine eigene Uhr mit dem
     Schluessel "mvFristStart" (Startzeitpunkt statt Enddatum) und der
     Auszeichnung .mvv__frist. Diese Auszeichnung wird seitdem nirgends mehr
     gerendert — der Zaehler lief ins Leere und loeschte im Sekundentakt einen
     Schluessel, den niemand las. Zwei Schluessel fuer dieselbe Frist ergeben
     ausserdem zwei verschiedene Restzeiten, sobald beide sichtbar sind.

     Diese Fassung tut nur die zwei Dinge, die der Theme-Baustein nicht tut:

     1. Einen abgelaufenen Eintrag WEGRAEUMEN, bevor der Baustein ihn liest.
        Ohne das blendet sich die Uhr auf der Warenkorbseite sofort selbst aus,
        waehrend das Warenkorb-Fenster beim naechsten Oeffnen mit frischen
        15 Minuten anfaengt. Hier wird nur GELOESCHT, nie geschrieben — das
        Setzen bleibt allein Sache des Bausteins.

     2. Den Kasten WEGNEHMEN, wenn keine Zeit mehr drinsteht. Beim Ablauf
        blendet der Baustein nur die Ziffern aus (Klasse tw-hidden), nicht den
        Satz drumherum; sonst stuende dort "… haben wir deine Artikel fuer
        Minuten reserviert". Dasselbe gilt, wenn der Baustein gar nicht ankommt.

     Der Warenkorb wird an keiner Stelle angefasst.
     --------------------------------------------------------------- */
  var MVV_SPEICHER = "countdown";  /* gehoert dem Theme-Baustein, nicht uns */
  var MVV_GNADE = 5000;            /* ms, die der Baustein zum Ankommen hat */
  var mvvSeitStart = Date.now();

  function mvvAbgelaufenesWegraeumen() {
    try {
      var wert = window.localStorage.getItem(MVV_SPEICHER);
      if (!wert) return;
      var ende = Date.parse(wert);
      /* Unlesbar oder vorbei: beides kann der Baustein nicht gebrauchen. Weg
         damit — dann faengt die Frist sauber von vorn an, und zwar fuer beide
         Uhren gleichzeitig, weil beide denselben Schluessel lesen. */
      if (isNaN(ende) || ende <= Date.now()) {
        window.localStorage.removeItem(MVV_SPEICHER);
      }
    } catch (e) {
      /* Privates Fenster oder gesperrter Speicher. Dann laeuft die Uhr nur
         fuer diese eine Seite — harmlos, im Gegensatz zu einer Ausnahme, die
         den Rest dieser Datei stoppen wuerde. */
    }
  }

  function mvvReservierungAufsicht() {
    var kaesten = doc.querySelectorAll(".mvv-reservierung");
    if (!kaesten.length) return;
    var nochGnade = (Date.now() - mvvSeitStart) < MVV_GNADE;
    for (var i = 0; i < kaesten.length; i++) {
      var kasten = kaesten[i];
      var uhr = kasten.querySelector("countdown-element");
      var minuten = kasten.querySelector(".js-timerMinutes");
      /* tw-hidden setzt der Baustein selbst, sobald die Frist abgelaufen ist. */
      var abgelaufen = !uhr || uhr.classList.contains("tw-hidden");
      var laeuft = !!(minuten && minuten.textContent !== "");
      /* Der Rueckweg muss offen bleiben: Dawn rendert diesen Bereich bei jeder
         Mengenaenderung neu, und ein einmal verstecktes Kaestchen darf nicht
         versteckt bleiben, wenn wieder eine Zeit drinsteht. */
      kasten.hidden = abgelaufen || (!laeuft && !nochGnade);
    }
  }

  if (doc.querySelector(".mvv-reservierung")) {
    /* Die Reihenfolge stimmt: mv-versand.js steht als defer-Skript im Kopf und
       laeuft damit VOR dem DOMContentLoaded, an dem das Theme-Buendel den
       Baustein 162 nachlaedt. Das Wegraeumen kommt also rechtzeitig. */
    mvvAbgelaufenesWegraeumen();
    mvvReservierungAufsicht();
    window.setInterval(mvvReservierungAufsicht, 1000);
  }

  /* Beim Laden nichts nachzucken lassen: Liquid hat den richtigen Stand schon
     gerendert. Nur wenn eine Anzeige ohne Serverstand dasteht, wird geholt. */
  if (doc.querySelector(".mvv") && !doc.querySelector(".mvv .mvv__text")) {
    ausKorbLesen();
  }
})();
